import React from 'react';
import styled from 'styled-components';

export default function Jumbotron(props: {
    children: React.ReactNode;
    text?: string;
    cta?: React.ReactNode;
    media?: React.ReactNode;
    reverse?: boolean;
}) {
    const Container = styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: ${(props: { reverse?: boolean }) =>
            reverse
                ? `
          'image children'
          'image cta'
        `
                : `
          'children image'
          'cta image'
      `};
        grid-column-gap: 2rem;
        grid-row-gap: 0.5rem;

        @media screen and (max-width: 767px) {
            grid-template-columns: 1fr;
            grid-template-areas:
                'children'
                'image'
                'cta';
            grid-row-gap: 1rem;
        }

        @media screen and (max-width: 499px) {
            padding: 0;
        }
    `;

    const Children = styled.div`
        grid-area: children;
    `;

    const CTA = styled.div`
        grid-area: cta;
        align-self: start;

        @media screen and (max-width: 767px) {
            > * {
                width: 100%;
            }
        }
    `;

    const Image = styled.div`
        grid-area: image;
        justify-self: center;
    `;

    const { children, cta, media, reverse } = props;

    return (
        <Container reverse={reverse}>
            <Children>{children}</Children>
            <CTA>{cta}</CTA>
            <Image>{media}</Image>
        </Container>
    );
}
